import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="relative border-b border-white/10 bg-black" data-id="element-251">
      <div className="container mx-auto px-4 py-4 flex items-center justify-between" data-id="element-252">
        <div className="flex items-center" data-id="element-253">
          <a href="/" className="flex items-center" data-id="element-254">
            <h1 className="text-xl font-light tracking-[0.2em] font-orbitron" data-id="element-255">
              <span className="text-white" data-id="element-256">LEX</span>
              <span className="text-zinc-400" data-id="element-257">SQUIRE</span>
            </h1>
          </a>
        </div>
        <nav className="hidden md:flex items-center space-x-8 text-sm" data-id="element-258">
          <a href="/features" className="text-zinc-300 hover:text-white transition-colors" data-id="element-259">
            Features
          </a>
          <a href="/pricing" className="text-zinc-300 hover:text-white transition-colors" data-id="element-260">
            Pricing
          </a>
          <a href="/vision" className="text-zinc-300 hover:text-white transition-colors" data-id="element-261">
            Vision
          </a>
          <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-4 py-2 rounded-sm hover:bg-zinc-200 transition-colors" data-id="element-262">
            Book Demo
          </a>
        </nav>
        <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-263">
          {isMenuOpen ? <X size={24} data-id="element-264" /> : <Menu size={24} data-id="element-265" />}
        </button>
      </div>
      {isMenuOpen && <div className="md:hidden absolute w-full bg-zinc-900 z-50 border-b border-white/10" data-id="element-266">
          <div className="container mx-auto px-4 py-4" data-id="element-267">
            <nav className="flex flex-col space-y-4" data-id="element-268">
              <a href="/features" className="text-zinc-300 hover:text-white transition-colors py-2" data-id="element-269">
                Features
              </a>
              <a href="/pricing" className="text-zinc-300 hover:text-white transition-colors py-2" data-id="element-270">
                Pricing
              </a>
              <a href="/vision" className="text-zinc-300 hover:text-white transition-colors py-2" data-id="element-271">
                Vision
              </a>
              <a href="https://calendly.com/lexsquire-info/30min" className="bg-white text-black px-4 py-2 rounded-sm hover:bg-zinc-200 transition-colors w-full mt-2 text-center" data-id="element-272">
                Book Demo
              </a>
            </nav>
          </div>
        </div>}
    </header>;
};